<template>
  <div ref="recaptchaEl"></div>
</template>

<script>
export default {
  name: "RecaptchaV2",

  props: {
    siteKey: { type: String, required: true }
  },

  emits: ["verified", "expired", "error"],

  data() {
    return {
      widgetId: null
    };
  },

  async mounted() {
    try {
      await this.loadRecaptchaScript();
      await this.$nextTick();
      this.render(true);
    } catch (err) {
      console.error("reCAPTCHA init error:", err);
      this.$emit("error", err);
    }
  },

  beforeUnmount() {
    this.teardown();
  },

  methods: {
    loadRecaptchaScript() {
      return new Promise((resolve, reject) => {
        const isReady = () =>
          window.grecaptcha && typeof window.grecaptcha.render === "function";

        if (isReady()) return resolve();

        const existing = document.querySelector('script[data-recaptcha="v2"]');
        if (existing) {
          const start = Date.now();
          const tick = () => {
            if (isReady()) return resolve();
            if (Date.now() - start > 10000)
              return reject(new Error("reCAPTCHA ready timed out"));
            setTimeout(tick, 50);
          };
          return tick();
        }

        const script = document.createElement("script");
        script.src = "https://www.google.com/recaptcha/api.js?render=explicit";
        script.async = true;
        script.defer = true;
        script.setAttribute("data-recaptcha", "v2");

        script.onload = () => {
          const start = Date.now();
          const tick = () => {
            if (isReady()) return resolve();
            if (Date.now() - start > 10000)
              return reject(new Error("reCAPTCHA ready timed out"));
            setTimeout(tick, 50);
          };
          tick();
        };

        script.onerror = () => reject(new Error("Failed to load reCAPTCHA script"));
        document.head.appendChild(script);
      });
    },

    render(force = false) {
      if (!this.$refs.recaptchaEl) return;

      if (force) {
        this.$refs.recaptchaEl.innerHTML = "";
        this.widgetId = null;
      }

      if (this.widgetId !== null) return;

      this.widgetId = window.grecaptcha.render(this.$refs.recaptchaEl, {
        sitekey: this.siteKey,
        callback: (token) => this.$emit("verified", token),
        "expired-callback": () => this.$emit("expired"),
        "error-callback": () => this.$emit("error")
      });
    },

    reset() {
      if (window.grecaptcha && this.widgetId !== null) {
        window.grecaptcha.reset(this.widgetId);
      }
    },

  teardown() {
  this.reset();
  this.widgetId = null;
  if (this.$refs.recaptchaEl) {
    this.$refs.recaptchaEl.innerHTML = "";
  }
}
  }
};
</script>
